/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Agenda_CloseInputs */

const cs_calendar_agenda_close = /** @type {(inputs: Calendar_Agenda_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zavřít agendu`)
};

const en_calendar_agenda_close = /** @type {(inputs: Calendar_Agenda_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close agenda`)
};

/**
* | output |
* | --- |
* | "Close agenda" |
*
* @param {Calendar_Agenda_CloseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_agenda_close = /** @type {((inputs?: Calendar_Agenda_CloseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Agenda_CloseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_agenda_close(inputs)
	return cs_calendar_agenda_close(inputs)
});